import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["editorKey"];
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIIconButton from 'UIComponents/button/UIIconButton';
import UIIcon from 'UIComponents/icon/UIIcon';
import { Fragment, useCallback } from 'react';
import styled from 'styled-components';
import { useShepherdDismissState } from '../../../compose/protected/hooks';
import { usePopOutEditorState } from '../hooks/usePopOutEditorState';
import { NewFeatureBadge } from './NewFeatureBadge';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ATTRIBUTE_STORAGE_PREFIX = `fullscreen-shepherd`;
const StyledUIIconButton = styled(UIIconButton).withConfig({
  displayName: "ToolbarExpandButton__StyledUIIconButton",
  componentId: "ti32vw-0"
})(["&&&{margin-left:0;}"]);
export const ToolbarExpandButton = _ref => {
  let {
      editorKey
    } = _ref,
    iconButtonProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    isOpen,
    open: openPopout,
    close: closePopout
  } = usePopOutEditorState(editorKey);
  const {
    isDismissed,
    setDismissed
  } = useShepherdDismissState({
    attributeKey: `${ATTRIBUTE_STORAGE_PREFIX}-${editorKey}`
  });
  const openAndDismissShepherd = useCallback(() => {
    openPopout();
    if (!isDismissed) setDismissed();
  }, [openPopout, setDismissed, isDismissed]);
  const handleClick = isOpen ? closePopout : openAndDismissShepherd;
  const tooltipMessage = /*#__PURE__*/_jsx(FormattedMessage, {
    message: isOpen ? 'composer-ui.pop-out.controls.collapse' : 'composer-ui.pop-out.controls.expand'
  });
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [!isOpen && !isDismissed && /*#__PURE__*/_jsx(NewFeatureBadge, {}), /*#__PURE__*/_jsx(StyledUIIconButton, Object.assign({
      "data-test-id": "tabbed-editor-expand-button",
      use: "transparent",
      tooltip: tooltipMessage,
      placement: "top"
    }, iconButtonProps, {
      onClick: handleClick,
      children: /*#__PURE__*/_jsx(UIIcon, {
        name: isOpen ? 'exitFullScreen' : 'enlarge'
      })
    }))]
  }, `expand-button-${isOpen ? 'open' : 'closed'}`);
};
ToolbarExpandButton.displayName = 'ToolbarExpandButton';